import React from "react";
import backgroundimg from "./../image/banner.png";
import Heading from "./Heading";
import { Helmet } from "react-helmet";

const CaseStudies = ({ title }) => {
  const isconsultant = title === "Consulting with Nexify Clients";
  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 mt-0">
      <Helmet>
        <title>Consulting for Healthcare - Nexify Infosystms</title>
        <meta name="description" content="Explore consulting services provided by Nexify, including IT strategy, technology consulting, and more." />
        <meta name="keywords" content="Consulting, IT Strategy, Technology Consulting, Nexify, Business Growth, Digital Transformation" />
      </Helmet>
      {/* Header Section */}
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${backgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            {/* 🔵 Dot Pattern Overlay Inside Box */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>

            <h1 className="text-[8vw] md:text-[66px]  font-semibold mb-2 whitespace-nowrap">
              Nexify Industry Experties
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
  Transforming Challenges into Solutions
</h2>

          </div>
        </div>

      </div>
      <div className="bg-white flex flex-col p-6 w-full max-w-[1320px] gap-6 mb-4 mt-4">
  <div className="w-full flex flex-col justify-center text-center md:text-left">
    <h1 className="text-[32px] text-[#0e55a8] font-semibold mb-6">
      Transforming Healthcare with Innovative IT Solutions
    </h1>
  </div>

  <div className="flex flex-col gap-4">
    <p className="text-[#6d6d70] text-[16px]" style={{ lineHeight: "1.8" }}>
    At Nexify Infosystems, we go beyond the conventional definitions of consulting and staffing- we are the architects of transformation, shaping the future of businesses with innovation, precision, and impact. Our dedicated team of industry experts and certified professionals is committed to delivering cutting-edge IT solutions that span a broad spectrum of capabilities, including Automation, Artificial Intelligence, Data Engineering, Cloud Computing, Cybersecurity, Healthcare Compliance & Solutions, Technology Consulting, and Advanced Talent Screening.
    </p>

    <p className="text-[#6d6d70] text-[16px]" style={{ lineHeight: "1.8" }}>
    We understand the unique challenges and stringent regulatory requirements of the healthcare sector, from HIPAA compliance to data security and patient privacy. Our comprehensive strategies are designed to seamlessly integrate these regulatory frameworks into your operations, ensuring that healthcare organizations can harness innovation without compromising on security or patient trust.
    </p>

    <p className="text-[#6d6d70] text-[16px]" style={{ lineHeight: "1.8" }}>
    With a foundation rooted in excellence and a relentless drive for innovation, we develop bespoke strategies that help businesses—and healthcare providers—realize their full potential. Whether navigating complex challenges or seizing emerging opportunities, our approach ensures every solution is aligned with your unique vision and objectives.
    </p>

    <p className="text-[#6d6d70] text-[16px]" style={{ lineHeight: "1.8" }}>
    At Nexify, we believe in building lasting relationships anchored in trust, collaboration, and measurable impact. We don’t just address immediate needs or challenges; we create sustainable pathways to growth and success. By turning complexity into opportunity, we deliver solutions that not only solve problems but also position businesses for long-term resilience and leadership in their industries.
    </p>

    <p className="text-[#6d6d70] text-[16px]" style={{ lineHeight: "1.8" }}>
    Our partnerships represent a legacy of success, a testament to our unwavering commitment to delivering enduring value. <br />
    With Nexify Infosystems, the future isn’t just anticipated—it’s designed. In a world where healthcare demands both innovation and compliance, we deliver IT solutions that not only transform operations but also uphold the highest standards of data security and regulatory excellence.
    </p>
  </div>
</div>

    </div>
  );
};

export default CaseStudies;
